<script lang="ts">
  let rating = [1,2,3,4,5]
</script>
<ul class="rating">
    {#each rating as ratingItem}
        <li>
            <i class="fa fa-star font-warning me-1"></i>
        </li>
    {/each}
</ul>